import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "CommentItem",
  props: {
    commentItem: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props) {
    var isLike = ref(false);

    var likeClick = function likeClick() {
      isLike.value = !isLike.value;
    };

    return {
      likeClick: likeClick
    };
  },
  components: {}
});